import React from "react";
import { Box, Typography } from "@mui/material";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
export function UpgradeButton({ msg, onUpgrade }) {
  return (
    <Box
      container
      spacing={1}
      onClick={onUpgrade}
      style={{ cursor: "pointer" }}
      sx={{
        display: "flex",
        alignItems: "center"
      }}>
      <Typography variant="body1">{msg}</Typography>
      <Box style={{ width: "12px" }}></Box>
      <ArrowForwardIos
        style={{
          width: "10px",
          height: "10px"
        }}
      />
    </Box>
  );
}
